import { Dropdown, Form, Input, Select, Typography } from 'antd';

import {
  botDetailsOptions,
  EXTRA_DEADLINES_LIST,
} from '@app/components/Modals/BotDetailsModal/data';

import type { DeadlineFieldsProps } from '../types';

const { Text } = Typography;

const {
  DEADLINES_LIST,
  CUSTOM_DEADLINE_ITEM_INDEX,
  BEFORE_RECORD_DEADLINE_ITEM_INDEX,
  AFTER_RECORD_DEADLINE_ITEM_INDEX,
} = botDetailsOptions;

export const DeadlineFields = ({
  title,
  deadlineFieldName,
  customDeadlineDayFieldName,
  customDeadlineTimeFieldName,
  selectedTriggerId,
  selectedDeadlineItem,
  dropdownOpen,
  displayValue,
  dropdownContent,
  setDropdownOpen,
  handleDeadlineChange,
  handleDeadlineDropdownOpenChange,
  validateNumericInput,
  onCustomDayInput,
  setTime,
  deadlineRawValue,
}: DeadlineFieldsProps) => {
  return (
    <div className="item-container">
      <Text className="label-require" strong>
        {title}
      </Text>

      <Form.Item
        name={deadlineFieldName}
        rules={[
          ({ getFieldValue }) => ({
            validator(_, value) {
              const customDeadlineDay = getFieldValue(
                customDeadlineDayFieldName
              );

              const customDeadlineTime = getFieldValue(
                customDeadlineTimeFieldName
              );

              if (value !== undefined && value !== null) {
                return Promise.resolve();
              }

              if (
                customDeadlineDay !== undefined &&
                customDeadlineDay !== null &&
                customDeadlineTime !== undefined &&
                customDeadlineTime !== null
              ) {
                return Promise.resolve();
              }

              return Promise.reject(
                new Error('Пожалуйста, выберите срок или укажите свое время')
              );
            },
          }),
        ]}
      >
        <Select
          placeholder="Выберите срок выполнения"
          options={
            selectedTriggerId === 'DateRecord'
              ? [...DEADLINES_LIST, ...EXTRA_DEADLINES_LIST]
              : DEADLINES_LIST
          }
          onChange={handleDeadlineChange}
        />
      </Form.Item>

      {(selectedDeadlineItem === CUSTOM_DEADLINE_ITEM_INDEX ||
        selectedDeadlineItem === BEFORE_RECORD_DEADLINE_ITEM_INDEX ||
        selectedDeadlineItem === AFTER_RECORD_DEADLINE_ITEM_INDEX) && (
        <div className="custom_deadline_row">
          <div className="days-input-container">
            <Text className="label-require">
              {selectedDeadlineItem === BEFORE_RECORD_DEADLINE_ITEM_INDEX
                ? 'За'
                : 'Через'}
            </Text>

            <Form.Item
              name={customDeadlineDayFieldName}
              className="item_custom_deadline_row_day"
              dependencies={[deadlineFieldName, customDeadlineTimeFieldName]}
              rules={[
                {
                  required: true,
                  message: 'Укажите количество дней',
                },
                {
                  validator: (_, value) => validateNumericInput(value),
                },
              ]}
              validateTrigger="onChange"
            >
              <Input
                type="text"
                className="custom_deadline_day_input"
                placeholder="от 0 до 180"
                maxLength={3}
                inputMode="numeric"
                pattern="\d*"
                onInput={(e) => onCustomDayInput(e, customDeadlineDayFieldName)}
              />
            </Form.Item>

            <Text className="label-require">дней</Text>
          </div>

          <Form.Item
            name={customDeadlineTimeFieldName}
            label=""
            dependencies={[deadlineFieldName, customDeadlineDayFieldName]}
            rules={[
              ({ getFieldValue }) => ({
                validator(_, value) {
                  const deadline = getFieldValue(deadlineFieldName);
                  const custom_deadline_day = getFieldValue(
                    customDeadlineDayFieldName
                  );

                  const isDeadlineValid =
                    deadline !== undefined && deadline !== null;
                  const isCustomDeadlineDayValid =
                    custom_deadline_day !== undefined &&
                    custom_deadline_day !== null;
                  const isCustomDeadlineTimeValid =
                    value !== undefined && value !== null;

                  if (isDeadlineValid) {
                    return Promise.resolve();
                  }

                  if (isCustomDeadlineDayValid && isCustomDeadlineTimeValid) {
                    return Promise.resolve();
                  }

                  return Promise.reject(
                    new Error(
                      'Пожалуйста, выберите срок или укажите свое время'
                    )
                  );
                },
              }),
              {
                required: true,
                message: 'Укажите время',
              },
            ]}
            className="item_custom_deadline_row_time"
          >
            <Dropdown
              open={dropdownOpen}
              onOpenChange={(open) =>
                handleDeadlineDropdownOpenChange(
                  open,
                  setDropdownOpen,
                  setTime,
                  deadlineRawValue
                )
              }
              popupRender={() => dropdownContent}
              trigger={['click']}
            >
              <Input
                readOnly
                value={displayValue}
                placeholder="Выберите часы, минуты и секунды"
                onClick={() => setDropdownOpen(true)}
                className="custom_deadline_row_time"
              />
            </Dropdown>
          </Form.Item>
        </div>
      )}
    </div>
  );
};
